import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includedItems } from '../data/content';
export function WhatYouGet() {
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="what-you-get-title" style={{
    paddingTop: "12px"
  }} data-id="element-173" data-mp="1026uqi186v4d">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-174" data-mp="l5fsm10635b2">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-175" data-mp="q3haiiluwyky">Sin sorpresas</p>
        <h2 id="what-you-get-title" className="mt-4 text-center font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-176" data-mp="1dtbl0tipeb21">
          Exactamente qué recibís hoy
        </h2>
        <ul className="mt-10 overflow-hidden rounded-2xl bg-paper shadow-soft ring-1 ring-cream-line" data-id="element-177" data-mp="142z0h1aw2hvw">
          {includedItems.map(item => <li key={item} className="flex items-center gap-4 border-b border-cream-line px-5 py-4 text-lg text-petrol last:border-0 sm:px-7" data-id="element-178" data-mp="18zh5m2a4si8r">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage-deep text-paper" data-id="element-179" data-mp="21hbdbxvny9iq">
                <CheckIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-180" data-mp="2vf0v59b9wo3k" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}